<template>
    <div class="button-top">
      <button class="mr20 btn-db" @click="showFilterModal(content)">Filter</button>
      <button class="mr20 btn-db">Export to Excel</button>
      <!-- Dokumen -->
      <div v-if="content === 'default'">
        <FilterDefault v-if="showModal" @closeModal="closeModal" />
      </div>
      <div v-else-if="content === 'akta'">
        <FilterAkta v-if="showModal" @closeModal="closeModal" />
      </div>
      <div v-else-if="content === 'komersial'">
        <FilterKomersial v-if="showModal" @closeModal="closeModal" />
      </div>
      <div v-else-if="content === 'perizinan'">
        <FilterPerizinan v-if="showModal" @closeModal="closeModal" />
      </div>

      <!-- Badan Usaha -->
      <div v-if="content === 'nasional'">
        <FilterNasional v-if="showModal" @closeModal="closeModal" />
      </div>
      <div v-else-if="content === 'internasional'">
        <FilterInternasional v-if="showModal" @closeModal="closeModal" />
      </div>
      <div v-else-if="content === 'khusus'">
        <FilterKhusus v-if="showModal" @closeModal="closeModal" />
      </div>
      <div v-else-if="content === 'internal_memo'">
        <FilterInternalMemo v-if="showModal" @closeModal="closeModal" />
      </div>

      <!-- Perorangan -->
      <div v-if="content === 'nasional'">
        <FilterNasionalP v-if="showModal" @closeModal="closeModal" />
      </div>
      <div v-else-if="content === 'internasional'">
        <FilterInternasionalP v-if="showModal" @closeModal="closeModal" />
      </div>
      <div v-else-if="content === 'khusus'">
        <FilterKhususP v-if="showModal" @closeModal="closeModal" />
      </div>
      <div v-else-if="content === 'internal_memo'">
        <FilterInternalMemoP v-if="showModal" @closeModal="closeModal" />
      </div>

    </div>
  </template>
  
  
  <script>
    export default {
  
      props: {
        'content': String,
      },
  
      components: {
        // Matrix Dokumen
        FilterDefault: () => import('@/components/masterdata/matrix/dokumen/filter/default.vue'),
        FilterAkta: () => import('@/components/masterdata/matrix/dokumen/filter/akta.vue'),
        FilterKomersial: () => import('@/components/masterdata/matrix/dokumen/filter/komersial.vue'),
        FilterPerizinan: () => import('@/components/masterdata/matrix/dokumen/filter/perizinan.vue'),

        // Badan Usaha
        FilterNasional: () => import('@/components/masterdata/matrix/badan-usaha/filter/nasional.vue'),
        FilterInternasional: () => import('@/components/masterdata/matrix/badan-usaha/filter/internasional.vue'),
        FilterKhusus: () => import('@/components/masterdata/matrix/badan-usaha/filter/khusus.vue'),
        FilterInternalMemo: () => import('@/components/masterdata/matrix/badan-usaha/filter/internal-memo.vue'),

        // Badan Usaha
        FilterNasionalP: () => import('@/components/masterdata/matrix/perorangan/filter/nasional.vue'),
        FilterInternasionalP: () => import('@/components/masterdata/matrix/perorangan/filter/internasional.vue'),
        FilterKhususP: () => import('@/components/masterdata/matrix/perorangan/filter/khusus.vue'),
        FilterInternalMemoP: () => import('@/components/masterdata/matrix/perorangan/filter/internal-memo.vue'),
        
      },
  
      data() {
        return {
          showModal: false,
        };
      },
  
      methods: {
        showFilterModal(content) {
          this.showModal = true;
        },
        closeModal() {
          this.showModal = false;
        },
      }
    }
  </script>